import * as types from "./actionTypes";
import API from "../../services/ClientLedgerService";
import { apiCallError, beginApiCall } from "./apiStatusActions";

export const loadClientLedgerSuccess = clientLedger => ({ type: types.LOAD_CLIENT_LEDGER_SUCCESS, clientLedger });
export const createClientLedgerSuccess = clientLedgerEntry => ({ type: types.CREATE_CLIENT_LEDGER_SUCCESS, clientLedgerEntry });
export const updateClientLedgerSuccess = clientLedgerEntry => ({ type: types.UPDATE_CLIENT_LEDGER_SUCCESS, clientLedgerEntry });
export const deleteClientLedgerOptimistic = clientLedgerEntry => ({ type: types.DELETE_CLIENT_LEDGER_OPTIMISTIC, clientLedgerEntry });

export function loadClientLedger(clientId = "") {
  return dispatch => {
    dispatch(beginApiCall("getClientLedger"));
    return API.getClientLedger(clientId)
      .then(clientLedger => {
        dispatch(loadClientLedgerSuccess(clientLedger));
        return clientLedger;
      })
      .catch(error => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function saveClientLedgerEntry(clientLedgerEntry, isNew = false) {
  return dispatch => {
    dispatch(beginApiCall("saveClientLedgerEntry"));
    return API.saveClientLedgerEntry(clientLedgerEntry, isNew)
      .then(savedEntry => {
        dispatch(isNew ? createClientLedgerSuccess(savedEntry) : updateClientLedgerSuccess(savedEntry));
        return savedEntry;
      })
      .catch(error => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function deleteClientLedgerEntry(clientLedgerEntry) {
  return dispatch => {
    dispatch(beginApiCall("deleteClientLedgerEntry"));
    return API.deleteClientLedgerEntry(clientLedgerEntry)
      .then(() => dispatch(deleteClientLedgerOptimistic(clientLedgerEntry)))
      .catch(error => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function replaceMonthlyCharge(existingEntry, newEntry) {
  return dispatch => (
    dispatch(saveClientLedgerEntry(
      existingEntry
        ? { ...newEntry, id: existingEntry.id, entryKey: existingEntry.entryKey }
        : newEntry,
      !existingEntry,
    ))
  );
}
